const PREFIX = 'MONEYBALL_VENDOR_LOOKUP';

const constants = {
  FETCH_VENDORS: `${PREFIX}/FETCH_VENDORS`,
  RECEIVE_VENDORS_DONE: `${PREFIX}/RECEIVE_VENDORS_DONE`,
};

export default constants;
